const { detect } = require('detect-browser')

export const device = detect() || {}
